import React, { useEffect, useRef, useState } from "react";

import filter from "../assets/images/filter.png";
import exportPic from "../assets/images/export.png";
import { Link } from "react-router-dom";
import DeletePodcast from "../components/podcast/DeletePodcast";
import { useDispatch } from "react-redux";
import { getPodcast, podcastStatusChanged } from "../features/slices/poadcast";
import { useSelector } from "react-redux";
import TableSkeleton from "../components/TableSkeleton";
import CommonPagination from "../components/CommonPagination";
import moment from "moment";
import { toastService } from "../utils/toastify";
import ExportToExcel from "../components/ExportToExcel";
import { canPerformAction } from "../utils/denyAccess";
const initalState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
  deleteModal: false,
  id: "",
  filterStatus: "",
};
const PodcastManagement = () => {
  const [iState, setUpdateState] = useState(initalState);
  const {
    searchQuery,
    fromDate,
    toDate,
    timeframe,
    status,
    deleteModal,
    id,
    filterStatus,
  } = iState;
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const { podcast, loading } = useSelector((state) => state?.podcast);
  const dispatch = useDispatch();
  const poadcastRef = useRef();
  useEffect(() => {
    dispatch(getPodcast({ page }));
  }, [page]);
  useEffect(() => {
    if (searchQuery?.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getPodcast({ search: searchQuery?.trim(), status: filterStatus })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value, page };
    dispatch(podcastStatusChanged(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getPodcast()).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const handleReset = () => {
    setUpdateState(initalState);
    dispatch(getPodcast({ page }));
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getPodcast(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getPodcast(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        // setUpdateState((prev) => ({
        //   ...prev,
        //   searchQuery: "",
        //   fromDate: "",
        //   toDate: "",
        //   timeframe: "",
        // }));
      }
    });
  };
  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      filterStatus: status,
    }));
    dispatch(
      getPodcast({
        status: status,
        search: searchQuery?.trim(),
      })
    );
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox justify-content-end mt-2">
            {canPerformAction("Podcasts") && (
              <Link to="addPodCast" className="TitleLink" state={{ add: true }}>
                <i className="fa-solid fa-plus" /> Add New Podcast
              </Link>
            )}
          </div>
          <div className="FilterArea">
            <div className="FilterLeft">
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  disabled={timeframe}
                  name="fromDate"
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  value={toDate}
                  disabled={timeframe}
                  onChange={(e) => handleSearch(e)}
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button className="Button" onClick={handleSubmit}>
                  Apply
                </button>
              </div>
              <div className="form-group">
                <label>Timeframe</label>
                <select
                  className="form-control customSelect"
                  name="timeframe"
                  value={timeframe}
                  disabled={fromDate || toDate}
                  onChange={(e) => handleTimeFrame(e)}
                >
                  <option value="" hidden>
                    Select
                  </option>
                  <option value="Today">Today</option>
                  <option value="Week">This Week</option>
                  <option value="Month">This Month</option>
                </select>
              </div>
            </div>
          </div>
          <div className="Small-Wrapper">
            <div className="NewFilter">
              <div className="SearchBox">
                <input
                  type="search"
                  className="SearchInput"
                  placeholder="Search here by ID, Name, or Others"
                  name="searchQuery"
                  value={searchQuery}
                  onChange={(e) => handleSearch(e)}
                />
                <span>
                  <i className="fa fa-search" />
                </span>
              </div>
              <div className="Actions">
                <div
                  className="form-group"
                  style={{
                    textAlign: "center",
                  }}
                >
                  <select
                    className="form-control FilterStatus"
                    name="status"
                    value={filterStatus}
                    onChange={(e) => handleFilter(e)}
                  >
                    <option value="" hidden>
                      Filter by Status
                    </option>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>
                <button className="Button Cancel" onClick={handleReset}>
                  <i className="fa fa-refresh" />
                </button>
                <ExportToExcel
                  ref={poadcastRef}
                  fileName="podcast"
                  type="course"
                />
              </div>
            </div>
            <div className="TableList">
              <table
                className="table-hover"
                style={{ width: "195%" }}
                ref={poadcastRef}
              >
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Podcast Name</th>
                    <th>Podcast Id</th>
                    <th>Category &amp; Topic</th>
                    <th>Total Avg. Reach</th>
                    <th>Release Date</th>
                    <th>Last Updated On</th>
                    <th>No. of Episodes</th>
                    <th>Avg. &amp; No. of Ratings</th>
                    <th>Status</th>
                    <th>Action</th>
                    {canPerformAction("Podcasts") && <th>Add Episodes</th>}
                  </tr>
                </thead>
                <tbody>
                  {!loading ? (
                    podcast?.result?.[0]?.paginationData.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1 + (page - 1) * 10}</td>
                          <td>{res?.podcastName}</td>
                          <td>{res?.podcast_number}</td>
                          <td>
                            {res?.categoryData?.[0]?.categoryName} &amp;{" "}
                            {res?.topicData?.[0]?.topicName}
                          </td>
                          <td>{res?.totalReach}</td>
                          <td>{moment(res?.createdAt).format("DD/MM/YYYY")}</td>
                          <td>{moment(res?.updatedAt).format("DD/MM/YYYY")}</td>
                          <td>{res?.epCounts}</td>
                          <td>
                            <Link
                              to={"/podcast/rating"}
                              className="LinkDirect"
                              state={res}
                            >
                              {Math.round(res?.averageRating) || 0} (
                              {res?.ratingCount})
                            </Link>
                          </td>
                          <td>
                            <span
                              className={
                                res?.status == "ACTIVE" ? "Green" : "Red"
                              }
                            >
                              {" "}
                              {res?.status == "ACTIVE"
                                ? "Available"
                                : "Removed"}
                            </span>
                          </td>
                          <td>
                            <div className="Actions justify-content-start">
                              {canPerformAction("Podcasts") && (
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={res?.status == "ACTIVE"}
                                    name="status"
                                    onChange={(e) => handleStatus(e, res?._id)}
                                  />
                                  <span className="slider" />
                                </label>
                              )}
                              <Link
                                to={"podcastDetail"}
                                className="Eyes"
                                state={res}
                              >
                                <i className="fa-regular fa-eye" />
                              </Link>
                              {canPerformAction("Podcasts") && (
                                <>
                                  <Link
                                    to={"editEpisode"}
                                    className="Edit"
                                    state={res}
                                  >
                                    <i className="fa-regular fa-pen-to-square" />
                                  </Link>
                                  <a
                                    className="Delete"
                                    onClick={() => {
                                      setUpdateState((prev) => ({
                                        ...prev,
                                        deleteModal: true,
                                        id: res?._id,
                                      }));
                                    }}
                                  >
                                    <i className="fa-regular fa-trash-can" />
                                  </a>
                                </>
                              )}
                            </div>
                          </td>
                          {canPerformAction("Podcasts") && (
                            <td>
                              <div className="Actions">
                                <Link
                                  to={"EpisodeList"}
                                  className="Black"
                                  state={{ podcastId: res?._id }}
                                >
                                  Add More & View All Episodes
                                </Link>
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <TableSkeleton
                      length={podcast?.result?.[0]?.paginationData?.length}
                    />
                  )}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              {podcast?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <>
                  <p>
                    Showing {(page - 1) * 10 + 1} to{" "}
                    {podcast?.result?.[0]?.paginationData?.length +
                      (page - 1) * 10}{" "}
                    of {podcast?.result?.[0]?.totalCount?.[0]?.count} results
                  </p>
                  <div className="PaginationRight">
                    {podcast?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                      <CommonPagination
                        activePage={page}
                        itemsCountPerPage={10}
                        totalItemsCount={
                          podcast?.result?.[0]?.totalCount?.[0]?.count || 0
                        }
                        pageRangeDisplayed={4}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {deleteModal && <DeletePodcast setUpdateState={setUpdateState} id={id} />}
    </>
  );
};

export default PodcastManagement;
